import FleetModal from '@/libs/antd/components/Modal';
import { useGetCalculateSimulation } from '@/libs/fleet-api/hooks/simulation';
import SimulationPreviewContent from './SimulationPreviewContent';
import { Spin } from 'antd';
import { FC } from 'react';

/**
 * View-only modal for displaying simulation results
 * Uses /api/credit-simulation/get-result endpoint to fetch existing simulation results
 */
interface SimulationResultModalProps {
	open: boolean;
	onClose: () => void;
	simulationId?: number;
}

const SimulationResultModal: FC<SimulationResultModalProps> = ({
	open,
	onClose,
	simulationId,
}) => {
	// Fetch simulation result directly using the get-result endpoint
	const { data: simulationResult, isLoading } = useGetCalculateSimulation({
		simulationId: open && simulationId ? simulationId : undefined,
	});

	// Don't render if no simulationId provided
	if (!simulationId) {
		return null;
	}

	const handleClose = () => {
		onClose();
	};

	return (
		<FleetModal
			open={open}
			onCancel={handleClose}
			width="90%"
			style={{ maxWidth: 1200 }}
			footer={null}
			title="Hasil Simulasi Kredit"
			destroyOnClose
		>
			{isLoading ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						minHeight: 400,
					}}
				>
					<Spin size="large" />
				</div>
			) : simulationResult ? (
				<div
					style={{ maxHeight: '70vh', overflowY: 'auto', padding: '0 16px' }}
				>
					<SimulationPreviewContent
						simulationResult={simulationResult}
						simulationId={simulationId}
					/>
				</div>
			) : (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						minHeight: 400,
						color: '#999',
					}}
				>
					Data simulasi tidak ditemukan
				</div>
			)}
		</FleetModal>
	);
};

export default SimulationResultModal;
